import {memo} from 'react';

import styled from 'styled-components';

import {MarkerTypeEnum} from './types';
import RestaurantMarker from './assets/restaurantMarker.svg?react';
import CustomerMarker from './assets/customerMarker.svg?react';
import CourierMarker from './assets/courierMarker.svg?react';

const SHARED_MARKERS_CSS = `
  width: 37px;
  height: 62px;
`;

const StyledRestaurantMarker = styled(RestaurantMarker).attrs({
  className: 'avoid-fill-stroke',
})`
  ${SHARED_MARKERS_CSS}
`;

const StyledCustomerMarker = styled(CustomerMarker).attrs({
  className: 'avoid-fill-stroke',
})`
  ${SHARED_MARKERS_CSS}
`;

const StyledCourierMarker = styled(CourierMarker).attrs({
  className: 'avoid-fill-stroke',
})`
  width: 57px;
  height: 66px;
`;

const MapMarkerTypeToComponent = {
  [MarkerTypeEnum.RESTAURANT]: StyledRestaurantMarker,
  [MarkerTypeEnum.CUSTOMER]: StyledCustomerMarker,
  [MarkerTypeEnum.COURIER]: StyledCourierMarker,
};

const Marker = ({type}: {type: MarkerTypeEnum}) => {
  const MarkerComponent = MapMarkerTypeToComponent[type];
  return <MarkerComponent />;
};

export default memo(Marker);
